import { URLS } from '../shared/url';
import { RefEntityTypeEnum } from '../models/enums';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var LookupCacheService = /** @class */ (function () {
    function LookupCacheService(http) {
        var _this = this;
        this.http = http;
        this.refEntityTypeEnum = RefEntityTypeEnum;
        this.load = function (apiServerURL) {
            return new Promise(function (resolve, reject) {
                _this.http.get("" + apiServerURL + URLS.getAllCacheLookups).toPromise().then(function (response) {
                    _this.lookups = response.result;
                    resolve();
                }).catch(function (err) {
                    reject("Could not load cache service");
                });
            });
        };
        this.getLookupCache = function (entityType) {
            return _this.lookups[_this.refEntityTypeEnum[entityType]];
        };
    }
    Object.defineProperty(LookupCacheService.prototype, "allLookups", {
        get: function () {
            return this.lookups;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LookupCacheService.prototype, "getStatus", {
        get: function () {
            return this.lookups.RefStatusType;
        },
        enumerable: true,
        configurable: true
    });
    LookupCacheService.ngInjectableDef = i0.defineInjectable({ factory: function LookupCacheService_Factory() { return new LookupCacheService(i0.inject(i1.HttpClient)); }, token: LookupCacheService, providedIn: "root" });
    return LookupCacheService;
}());
export { LookupCacheService };
